module.exports = __webpack_public_path__ + "media/images/apple-touch-icon-120x120-26aa7406a480a92b44a9fe46c08cbb8a.png";